import { ApplicationStartScreen } from "@/interactors/ApplicationStartScreen";

export default function Start() {
  return <ApplicationStartScreen />;
}
